import React from "react";
import { Popup } from "react-map-gl";
import { views } from "../../constants";
import {
  cleanEnergyTechnologyLabel,
  solarOwnershipLabel,
} from "../../utils";
import {
  StyledPopup,
  PopupHeader,
  PopupTitle,
  PopupSubtitle,
  PopupContent,
  PopupContentTitle,
} from "../Popup/styled";

function SchoolPopup({
  className,
  data,
  children,
  isS4sGrant,
  mapView,
  ...props
}) {
  return (
    <StyledPopup className={className} $mapView={mapView} {...props} as={Popup}>
      <PopupHeader $mapView={mapView}>
        <PopupTitle>{data.title}</PopupTitle>
        <PopupSubtitle>
          {data.subTitle && (
            <>
              {data.subTitle}
              <br />
            </>
          )}
          {data.city}
          {data.state ? `, ${data.state}` : ""}
        </PopupSubtitle>
      </PopupHeader>
      <PopupContent>
        {mapView === views.S4S_GRANTEES && (
          <PopupContentTitle>
            Awarded by Solar For Schools Grant Program
          </PopupContentTitle>
        )}
        {mapView === views.MEA_GRANTEES && (
          <PopupContentTitle>
            Awarded by Maryland Energy Administration's Decarbonizing Public Schools Program
          </PopupContentTitle>
        )}
        <ul>
          {cleanEnergyTechnologyLabel(data.cleanEnergyTechnology) && (
            <li>
              <span>Clean Energy Technology:</span>{" "}
              {cleanEnergyTechnologyLabel(data.cleanEnergyTechnology)}
            </li>
          )}
          {data.systemSize && (
            <li>
              <span>Solar Capacity:</span> {data.systemSize}{" "}
              {Number.parseFloat(data.systemSize) ? "kW" : ""}
            </li>
          )}
          {data.grantAmount && (
            <li>
              <span>Grant Amount:</span> {data.grantAmount}{" "}
            </li>
          )}
          {data.fiscalYear && (
            <li>
              <span>Fiscal Year:</span> {data.fiscalYear}{" "}
            </li>
          )}
          {data.yearInstalled && (
            <li>
              <span>Year Installed:</span>{" "}
              {data.yearInstalled
                .toString()
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
                .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
                .join(", ")}
            </li>
          )}
          {solarOwnershipLabel(data.solarOwnership) && (
            <li>
              <span>Solar Ownership:</span>{" "}
              {solarOwnershipLabel(data.solarOwnership)}
            </li>
          )}
          {data.structureType && (
            <li>
              <span>Solar Structure:</span> {data.structureType}
            </li>
          )}
          {data.batteryCapacity && (
            <li>
              <span>Battery Capacity:</span> {data.batteryCapacity}{" "}{Number.parseFloat(data.batteryCapacity) ? "kWh" : ""}
            </li>
          )}
          {data.batteryPower && (
            <li>
              <span>Battery Power:</span> {data.batteryPower}{" "}{Number.parseFloat(data.batteryPower) ? "kW" : ""}
            </li>
          )}
          {data.aoiCategory && (
            <li>
              <span>Area of Interest (AOI):</span> {data.aoiCategory}
            </li>
          )}
        </ul>
        {data.caseStudyURL && (
          <a href={data.caseStudyURL} target="_blank" rel="noreferrer">
            Case Study
          </a>
        )}
      </PopupContent>
    </StyledPopup>
  );
}

export default SchoolPopup;
